export function mascaraCpf(valor: string) {
  if (valor.length !== 11) return valor;
  return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
}

export function mascaraCnpj(valor: string) {
  if (valor.length !== 14) return valor;
  return valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

export function mascaraCelular(valor: string | null | undefined) {
  if (!valor) return '';
  if (valor.length === 10) {
    return valor.replace(/(\d{2})(\d{4})(\d{4})/g,"(\$1) \$2-\$3");
  } else if (valor.length === 11) {
    return valor.replace(/(\d{2})(\d{5})(\d{4})/g,"(\$1) \$2-\$3");
  } else {
    return valor;
  }
}

export function mascaraMatricula(valor: string) {
  if (valor) {
    let semestre = valor.substring(0, 1);
    let ano = valor.substring(1, 5);
    let numero = valor.substring(5);
    return `${semestre}/${ano}-${numero}`;
  }
  return valor; // Retorna o valor original se não for válido
}